import { request } from "utils/request"
import { asyncAction } from "./common"


const initialState = {
  taskLog: [],
  instrumentLog: [],
  sampleLog: []
}

export function reducer(state = initialState, action) {
  switch (action.type) {
    case "logging/fetch":
      return { ...state, taskLog: action.res }
    case "logging/fetchInstrument":
      return { ...state, instrumentLog: action.res }
    case "logging/fetchSample":
      return { ...state, sampleLog: action.res }
    default:
      return state
  }
}

export const fetchLog = asyncAction("logging/fetch", (dispatch) => {
  return request("GET", `/logging/task-change-logs`).then((res) => {
    return res.items
  })
})

export const fetchInstrumentLog = asyncAction("logging/fetchInstrument", (dispatch) => {
  return request("GET", `/logging/instrument-movement-logs`).then((res) => {
    return res.items
  })
})

export const fetchSampleLog = asyncAction("logging/fetchSample", (dispatch) => {
  return request("GET", `/logging/sample-change-logs`).then((res) => {
    return res.items
  })
})
